import React, { useState } from 'react';

import {
  Box,
  Button,
  HStack,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
} from '@chakra-ui/react';
import { FaEdit } from 'react-icons/fa';

import UpdateSupplierShippingModal from 'features/suppliers/components/UpdateSupplierShippingModal';

const EditableSupplierShippingCell = ({
  displayValue,
  supplierId,
  supplierName,
  sku,
  initialCost,
  inventoryIncludesShipping,
  externalShippingCost,
  onSaved,
  textColor,
  mutedTextColor,
  borderColor,
  tooltipBg,
  tooltipBorder,
  tooltipShadow,
}) => {
  const [isEditOpen, setIsEditOpen] = useState(false);

  const canEdit =
    inventoryIncludesShipping === false &&
    !!supplierId &&
    !!(sku && String(sku).trim());

  const resolvedCost =
    externalShippingCost != null && Number.isFinite(Number(externalShippingCost))
      ? Number(externalShippingCost)
      : initialCost;

  const openEditModal = (e) => {
    e?.stopPropagation?.();
    setIsEditOpen(true);
  };

  if (!canEdit) {
    return (
      <Text fontSize="sm" color={textColor}>
        {displayValue}
      </Text>
    );
  }

  return (
    <>
      <Popover
        trigger="hover"
        placement="top"
        openDelay={150}
        closeDelay={350}
        gutter={10}
        isLazy
      >
        <PopoverTrigger>
          <Box
            as="button"
            type="button"
            display="inline-block"
            cursor="pointer"
            borderBottomWidth="1px"
            borderBottomStyle="dotted"
            borderBottomColor="blue.400"
            bg="transparent"
            border="none"
            p={0}
            onClick={openEditModal}
            aria-label="Edit shipping price"
          >
            <Text fontSize="sm" color={textColor}>
              {displayValue}
            </Text>
          </Box>
        </PopoverTrigger>
        <PopoverContent
          w="auto"
          bg={tooltipBg}
          borderColor={tooltipBorder}
          boxShadow={tooltipShadow}
          _focus={{ boxShadow: tooltipShadow }}
        >
          <PopoverArrow bg={tooltipBg} />
          <PopoverBody px={3} py={2}>
            <HStack spacing={2}>
              <Text fontSize="sm" color={textColor} whiteSpace="nowrap">
                Edit shipping
              </Text>
              <Button
                size="xs"
                colorScheme="blue"
                leftIcon={<FaEdit />}
                onClick={openEditModal}
              >
                Edit
              </Button>
            </HStack>
          </PopoverBody>
        </PopoverContent>
      </Popover>

      <UpdateSupplierShippingModal
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        supplierId={supplierId}
        supplierName={supplierName}
        sku={sku}
        initialCost={resolvedCost}
        inventoryIncludesShipping={inventoryIncludesShipping}
        onSaved={onSaved}
        textColor={textColor}
        secondaryTextColor={mutedTextColor}
        borderColor={borderColor}
      />
    </>
  );
};

export default EditableSupplierShippingCell;
